module.exports = __webpack_public_path__ + "img/power-lines.af7fc8bd.jpg";